import { combineReducers, configureStore, createSlice } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
  key: 'root',
  storage,
}

const authInitialState = {
  user: null,
  token: null,
};

const userProfileInitialState = {
  userId: null,
  userName: null,
  firstName: null,
  creationDate: null,
  userRole: null,
  transcriptService: null,
  subscribedFeatures: [],
  creditsBalance: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: authInitialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
    },
  },
});

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState: userProfileInitialState,
  reducers: {
    setUserProfile: (state, action) => {
      const profile = action.payload;
      state.userId = profile.userId;
      state.userName = profile.userName;
      state.firstName = profile.firstName;
      state.creationDate = profile.creationDate;
      state.userRole = profile.userRole;
      state.transcriptService = profile.transcriptService;
      state.subscribedFeatures = profile.subscribedFeatures || [];
      state.creditsBalance = profile.creditsBalance ?? null;
    },
    updateTranscriptService: (state, action) => {
      state.transcriptService = action.payload;
    },
    updateSubscribedFeatures: (state, action) => {
      state.subscribedFeatures = action.payload;
    },
  },
});

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  userProfile: userProfileSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

// Export auth actions
export const { login, logout } = authSlice.actions;

// Export user profile actions
export const {
  setUserProfile,
  updateTranscriptService,
  updateSubscribedFeatures,
} = userProfileSlice.actions;

export default store;
